import { REGION_COUNTRY } from '../../App/common/constant';

export const findCountryRegion = (country) => {
  const region = Object.keys(REGION_COUNTRY).find((region) => REGION_COUNTRY[region][country]);
  return region || '';
};
